import { render, staticRenderFns } from "./DetailCommentInfo.vue?vue&type=template&id=b81472aa&scoped=true&"
import script from "./DetailCommentInfo.vue?vue&type=script&lang=js&"
export * from "./DetailCommentInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailCommentInfo.vue?vue&type=style&index=0&id=b81472aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81472aa",
  null
  
)

export default component.exports